import { Directive, HostBinding } from '@angular/core';
import { NgModel } from '@angular/forms';
import { listSubtitleStyles } from '@kite_aerolab/shared/components';

@Directive({
  selector: '[listSubtitle]',
  providers: [NgModel],
})
export class ListSubtitleDirective {

  @HostBinding('class')
  public get setClasses() {
    return listSubtitleStyles({
    }).className;
  }
}
